import { render, staticRenderFns } from "./HeaderBrand.vue?vue&type=template&id=4ffa716a&"
import script from "./HeaderBrand.vue?vue&type=script&lang=js&"
export * from "./HeaderBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports